<template>
  <base-card :show-button="false"
             :size="size"
             width-auto
             @click="openChildMenu">
    <div slot="title">
      {{ $t("profileSettings.title") }}
    </div>

    <div slot="content"
         class="profile-settings">
      <child-avatar :child="child"
                    show-out-of-sync
                    out-of-sync-position="right" />

      <div class="divider" />

      <child-menu class="standard-restrictions-menu"
                ref="childMenu"
                :mode-id="modeId"
                :child-id="childId"
                :size-big="this.$mq != 'mobile'" />
    </div>
  </base-card>
</template>

<script>
  import ChildAvatar from '@/components/Child/ChildAvatar.vue'
  import ChildMenu from '@/components/Child/ChildMenu/ChildMenu.vue'

  export default {
    props: {
      childId: {
        type: String,
        required: true
      },

      size: {
        type: String,
        default: 'auto'
      }
    },

    components: {
      ChildAvatar,
      ChildMenu
    },

    computed: {
      ...mapGetters('auth', {
        currentUser: 'currentUser'
      }),

      ...mapGetters('children', {
        getChildById: 'getById'
      }),

      child() {
        return this.getChildById(this.childId)
      },

      modeId() {
        return this.child ? this.child.current_rule.mode_id : ''
      }
    },

    methods: {
      openChildMenu() {
        this.$refs.childMenu.onRestrictionsMenuClick()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .profile-settings {
    width: 125px;
    display: flex;
    justify-content: space-between;
  }
</style>